import { createInteractiveColorVars } from '../../helpers/createInteractiveColorVars/index.js';

const LineColors = createInteractiveColorVars('line');
const LineColorsLightValues = Object.freeze({
    base: {
        default: '#06C755',
        action: '#1FCD66',
        active: '#048B3C',
        activeAction: '#06C755',
    },
    text: {
        default: '#ffffff',
        action: '#ffffff',
        active: '#ffffff',
        activeAction: '#ffffff',
    },
});
const LineColorsDarkValues = Object.freeze({
    base: {
        default: '#06C755',
        action: '#1FCD66',
        active: '#048B3C',
        activeAction: '#06C755',
    },
    text: {
        default: '#ffffff',
        action: '#ffffff',
        active: '#ffffff',
        activeAction: '#ffffff',
    },
});

export { LineColors, LineColorsDarkValues, LineColorsLightValues };
